import { useEffect, useState } from "react";
import { LoginPage } from "./pages/LoginPage";
import { Dashboard } from "./pages/DashboardPage";
import { BrowserRouter, Route, RouterProvider, Routes } from "react-router-dom";
import SolicitarTrocaSenha from "./pages/SolicitarTrocaSenha";
import { TrocarSenhaPage } from "./pages/TrocarSenhaPage";

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={isLoggedIn ? (
            <Dashboard onLogout={() => setIsLoggedIn(false)} />
          ) : (
            <LoginPage onLogin={() => setIsLoggedIn(true)} />
          )} />
          <Route path="/trocarSenha" element={<TrocarSenhaPage />} />
          <Route path="/solicitarTrocaSenha" element={<SolicitarTrocaSenha />} />
        </Routes>
      </BrowserRouter>

    </>
  );
}
